<div class="background-unicamp">

  <div class="card">

    <mat-card appearance="outlined">

      <app-logo></app-logo>

      @if (emailEnviado == false) {
        <mat-card-content>
          <form [formGroup]="formGroupEmail">

            <mat-form-field class="inputs margin" appearance="outline">
              <mat-label>{{ "validaemail.email_valido" | translate}}</mat-label>
              <input type="email" matInput formControlName="email">
            </mat-form-field>

            @if (formGroupEmail.invalid) {
              <div class="error">
                @if (formGroupEmail.hasError('required')) {
                  <small class="error">{{ "validaemail.email_obrigatorio" | translate }}</small>
                }
                @if (formGroupEmail.hasError('email')) {
                  <small class="error">{{  "validaemail.email_invalido" | translate }}</small>
                }
                @if (formGroupEmail.hasError('emailAlreadyExists')) {
                  <small class="error">{{ "validaemail.email_cadastrado" | translate }}</small>
                }
              </div>
            }

            <mat-card-actions class="buttons">
              <button (click)="enviarEmail()" matButton="filled">{{ "alterasenha.enviar_email" | translate }}</button>
            </mat-card-actions>
          </form>
        </mat-card-content>
      }


      @if (emailEnviado == true) {
          <form [formGroup]="formGroupCode">

            <mat-card-content>
              <mat-card-header>
                <p class="mat-caption" class="text-mute">{{ "validaemail.enviado_email_para" | translate}} <span class="text-bold">{{ formGroupEmail.value.email }}</span></p>
              </mat-card-header>

                <p class="text-mute center">{{ "validaemail.informe_codigo" | translate }}</p>

              <div class="code">

                <input type="text" maxlength="1" appNumberOnly formControlName="code1">
                <input type="text" maxlength="1" appNumberOnly formControlName="code2">
                <input type="text" maxlength="1" appNumberOnly formControlName="code3">
                <input type="text" maxlength="1" appNumberOnly formControlName="code4">
              </div>

              @if (formGroupCode.invalid) {
                <div class="error">
                  @if (formGroupCode.hasError('invalidCode')) {
                    <div>{{ "validaemail.codigo_confirmacao_invalido" | translate }}</div>
                  }
                </div>
              }
              <mat-card-actions class="buttons">

                <button type="button" (click)="voltar()" mat-button>{{ "validaemail.voltar" | translate}}</button>
                <button (click)="confirmar()" matButton="filled">{{ 'validaemail.confirmar' | translate}}</button>
              </mat-card-actions>
            </mat-card-content>
          </form>
        }

    </mat-card>
  </div>
</div>

@if (loading) {
  <div class="loader-overlay">
    <mat-spinner ></mat-spinner>
  </div>
}
